import { Component, OnDestroy } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as moment from 'moment';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-datetime-notifications-picker',
  templateUrl: './datetime-notifications-picker.component.html',
  styleUrls: ['./datetime-notifications-picker.component.scss'],
})
export class DatetimeNotificationsPickerComponent implements OnDestroy {
  public day: string;
  public currentStart: string;
  public currentEnd: string;
  public allowNotifications: boolean;

  public maxDate = (Number(new Date().getFullYear()) + 1) + '-12-31';
  public customDate: any;
  public currentTime: any;

  public defaultDate: any;
  public defaultTime: any;

  public localeString: string;
  public customPres: string = 'date-time';
  public paramPres: string;
  public currentDate: string;

  public modalType = 1;
  minInsterval: number[];
  typeTimeActive = 0;

  constructor(private modalCtrl: ModalController, public storageService: LocalStorageNativeService) { }

  ngOnInit() {

    if(this.allowNotifications === undefined){
      this.allowNotifications = true;
    }

    if (this.currentStart === undefined) {
      //this.currentStart = '2024-01-01 09:00'; 
      this.currentDate = moment().format('YYYY-MM-DD hh:mm:ss A');
      //this.currentStart = moment().toString();
      console.log('this.currentDate: ', this.currentStart);
      this.defaultDate = this.currentDate;

      // Obtener la hora actual en el formato hh:mm
      this.currentStart = moment(this.currentDate).format('YYYY-MM-DD hh:mm:ss A');

      this.currentEnd = moment(this.currentDate).format('YYYY-MM-DD hh:mm:ss A');
      // Añadir 1 hora a la hora de inicio para establecer el valor de currentEnd
      //this.currentEnd = moment(this.currentDate, 'hh:mm').add(1, 'hours').format('YYYY-MM-DD hh:mm:ss');

      console.log('Hora de inicio:', this.currentStart);
      console.log('Hora de finalización:', this.currentEnd);
    }



    // if(this.customDate){
    //   this.defaultDate = this.customDate;
    //   const splitTime = this.customDate.toString().split('T');
    //   this.defaultTime = splitTime[1].slice(0, 5);//this.customDate;
    // }
    // else{
    //   this.currentDate = moment().add(1, 'days').format('YYYY-MM-DD')+ 'T01:01:01-01:00';
    //   //this.currentDate = moment().add(1, 'days').format("YYYY-MM-DD");
    //   this.defaultDate = this.currentDate;
    //   console.log('this.currentDate: ', this.currentDate);
    //   const splitTime = this.currentDate.toString().split('T');
    //   this.defaultTime = splitTime[1].slice(0, 5);
    // }

    this.getLanguageApp();
    if (this.paramPres) {
      this.customPres = this.paramPres;
    }
  }

  onTimeChangeStart(event: any) {
    this.currentStart = moment(event.detail.value).format('YYYY-MM-DD HH:mm:ss');
  }

  onTimeChangeEnd(event: any) {
    this.currentEnd = moment(event.detail.value).format('YYYY-MM-DD HH:mm:ss');
  }

  async getLanguageApp() {
    const language = await this.storageService.getItem('selectedLanguage');
    if (language || language !== null) {
      this.localeString = (language === 'es') ? 'es-MX' : 'en-US';
    }
    else {
      this.localeString = 'en-US';
    }
  }

  ngOnDestroy() { }

  async close() {
    this.modalCtrl.dismiss();
  }

  selectDate() {
    const formattedStart = moment(this.currentStart).format('h:mm a');
    const formattedEnd = moment(this.currentEnd).format('h:mm a');

    this.modalCtrl.dismiss({
        allow: this.allowNotifications,
        currentStart: formattedStart,
        currentEnd: formattedEnd
    });
  }

  setTypeTimeActive(_type: number) {
    console.log('_type: ', _type)
    console.log('this.typeTimeActive: ', this.typeTimeActive)
    if (this.typeTimeActive === 1 && _type === 1) {
      this.typeTimeActive = 0;
    }
    else if (this.typeTimeActive === 0 && _type === 1) {
      this.typeTimeActive = 1;
    }
    else if (this.typeTimeActive === 2 && _type === 2) {
      this.typeTimeActive = 0;
    }
    else if (this.typeTimeActive === 0 && _type === 2) {
      this.typeTimeActive = 2;
    }
    else if (this.typeTimeActive === 1 && _type === 2) {
      this.typeTimeActive = 2;
    }
    else if (this.typeTimeActive === 2 && _type === 1) {
      this.typeTimeActive = 1;
    }
  }

}
